<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>添加学生 / 家长</h1>
      </div>
      <div class="liner"></div>
    </div>

    <div class="main-page" style="padding-bottom:0;">
      <div class="margin-15 text-center">
        <p class="padding-15 margin-15 font-16">面对面扫一扫，邀请家长添加学生</p>
        <div class="margin-15"><div class="text-center" id="code"></div></div>
        <div class="liner"></div>
        <p class="padding-15 gray">您还可以发邀请到</p>

        <div class="shall padding-15">
        <div class="clearfix font-10">
          <div class="col-xs-4"><a class="icon-weixin icon gray" @click.prevent="shareToFriends()">家长的微信</a></div>
          <div class="col-xs-4"><a class="icon-qq icon gray" @click.prevent="shareQQ()">家长的QQ</a></div>
          <div class="col-xs-4"><router-link class="icon-shoudong icon gray" :to="{path:'/student/add'}">手动添加</router-link></div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      shareInfo: {}
    }
  },
  mounted: function () {
    this.shareToPeople()
  },
  methods: {
    shareToPeople: function () {
      this.isideShare = false
      this.shareInfo.curcheName = this.login_data[this.cookie_login_data.index].curcheName
      this.shareInfo.teacherName = this.login_data[this.cookie_login_data.index].teacherName
      this.shareInfo.description = this.shareInfo.teacherName + '邀请你加入' + this.shareInfo.curcheName
      if (this.cookie_login_data.teacherIcon) {
        this.shareInfo.imageUrl = this.cookie_login_data.baseAcessPath + this.cookie_login_data.teacherIcon
      } else {
        this.shareInfo.imageUrl = 'http://download.shurenapp.com/invitation/assets/images/img-default.png'
      }
      this.shareInfo.title = '邀请家长'
      this.shareInfo.webpageUrl = 'http://download.kids-home.cc/invitation/invitation-parents.html?' + 'curcheId=' + this.cookie_login_data.curcheId + '&' + 'teacherId=' + this.cookie_login_data.teacherId
      // this.shareInfo.webpageUrl = 'http://192.168.1.162:8090/shuren_h5/invitation/invitation-parents.html?' + 'curcheId=' + this.cookie_login_data.curcheId + '&' + 'teacherId=' + this.cookie_login_data.teacherId

      $('#code').qrcode({
        text: this.shareInfo.webpageUrl
      })
    },
    shareToTimeLine: function (para) {
      window.Wechat.share({
        message: {
          title: this.shareInfo.title,
          description: this.shareInfo.description,
          // thumb: this.shareInfo.thumb,
          messageExt: this.shareInfo.title,
          media: {
            type: window.Wechat.Type.LINK,
            webpageUrl: this.shareInfo.webpageUrl
          }
        },
        scene: window.Wechat.Scene.TIMELINE   // share to Timeline
      }, function () {
        // alert('分享成功')
      }, function (reason) {
        // alert('失败原因: ' + reason)
      })
    },
    shareToFriends: function (para) {
      window.Wechat.share({
        message: {
          title: this.shareInfo.title,
          description: this.shareInfo.description,
          thumb: this.shareInfo.thumb,
          messageExt: this.shareInfo.title,
          media: {
            type: window.Wechat.Type.LINK,
            webpageUrl: this.shareInfo.webpageUrl
          }
        },
        scene: window.Wechat.Scene.SESSION
      }, function () {
        // alert('分享成功')
      }, function (reason) {
        // alert('失败原因:' + reason)
      })
    },
    shareQQ: function (para) {
      var args = {}
      args.url = this.shareInfo.webpageUrl
      args.title = this.shareInfo.title
      args.description = this.shareInfo.description
      args.imageUrl = this.shareInfo.imageUrl
      args.appName = this.shareInfo.title
      window.YCQQ.shareToQQ(function () {
        console.log('share success')
      }, function (failReason) {
        console.log(failReason)
      }, args)
    },
    loadTop: function (id) {
      // alert('123')
      this.$refs.loadmore.onTopLoaded(id)
    }
  }
}
</script>
<style scoped>
  canvas{margin:0 auto;width:100%;background:#f00;}
</style>



// WEBPACK FOOTER //
// parents.vue?7b5e3622